import { Component } from '@angular/core';

@Component({
  selector: 'app-layout-style-without-navigation',
  templateUrl: './layout-style-without-navigation.component.html',
  styleUrls: ['./layout-style-without-navigation.component.css']
})
export class LayoutStyleWithoutNavigationComponent  {

  constructor() { }

 
}
